import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { configureStore } from './redux/Store';
import './data';
import * as serviceWorker from './serviceWorker';
import reportWebVitals from './reportWebVitals';
import Spinner from './views/spinner/Spinner';
import { apiGetSession } from './apis';

const renderApp = () => {
  const App = lazy(() => import('./App'));
  const root = ReactDOM.createRoot(document.getElementById('root'));

  root.render(
    <Provider store={configureStore()}>
      <Suspense fallback={<Spinner />}>
        <HashRouter>
          <App />
        </HashRouter>
      </Suspense>
    </Provider>
  );
};

const renderInitError = () => {
  const container = document.getElementById('root');
  if (!container) return;

  container.innerHTML = `
    <div style="min-height:100vh;display:flex;align-items:center;justify-content:center;font-family:'Plus Jakarta Sans',system-ui,-apple-system,sans-serif;background:#f6f9fc;padding:24px;">
      <div style="max-width:420px;text-align:center;background:#ffffff;border-radius:16px;padding:40px 32px;box-shadow:0 12px 32px rgba(15,23,42,0.08);">
        <h1 style="margin:0 0 12px;font-size:1.25rem;color:#111827;">No pudimos conectar con el servidor</h1>
        <p style="margin:0 0 24px;font-size:0.95rem;line-height:1.5;color:#4b5563;">
          Revisa tu conexión a internet e inténtalo nuevamente. Si el problema persiste, contacta a soporte.
        </p>
        <button id="init-retry" style="border:none;border-radius:10px;padding:12px 24px;font-size:0.95rem;font-weight:600;color:#ffffff;background:#5d87ff;cursor:pointer;">
          Reintentar
        </button>
      </div>
    </div>
  `;

  const retryButton = document.getElementById('init-retry');
  if (retryButton) {
    retryButton.addEventListener('click', () => window.location.reload());
  }
};

const initalization = async () => {
  try {
    const result = await apiGetSession();
    if (result && result.init) {
      localStorage.setItem('session', result.init);
    }
  } catch (error) {
    console.error('Error during initialization:', error);

    // La clave de sesión es estable entre peticiones, así que una copia previa
    // sirve para arrancar cuando la petición se aborta o la API no responde.
    if (!localStorage.getItem('session')) {
      renderInitError();
      return;
    }
  }

  renderApp();
};

// Desactiva el service worker por defecto
serviceWorker.unregister();

// Reporta métricas de rendimiento
reportWebVitals();

// Lanza la inicialización
initalization();
